module.exports = __webpack_public_path__ + "static/img/2a.a751f216.webp";